// Runtime-generated stand-in art for sub-project 1: diamond ground tiles and round crop
// markers (white, tinted per crop). Authored at 2× like every other texture and shown at
// TILE_W×TILE_H. Real tiles/sheets replace these keys in sub-project 6.
import { TILE_W, TILE_H } from './iso.mjs';
import { TOOLS, vehicleKey } from './vehicles.mjs';

export const TILE_KEYS = {
  grass: 'farm_tile_grass', fallow: 'farm_tile_fallow', plowed: 'farm_tile_plowed',
  hover: 'farm_tile_hover', queued: 'farm_tile_queued',
};
export const CROP_KEYS = { seedling: 'farm_crop_seedling', growing: 'farm_crop_growing', ready: 'farm_crop_ready' };
export const CROP_TINT = {
  rzodkiewka: 0xe0485a, salata: 0x7ed957, marchewka: 0xff8c2a,
  pomidor: 0xe23b2e, ziemniak: 0xc9a26b, pszenica: 0xe8c547,
  truskawka: 0xe8344a, cukinia: 0x4f9a3a, ogorek: 0x3e8a3a, malina: 0xc2185b, papryka: 0xd83a2a,
  dynia: 0xf08a24, kukurydza: 0xf2c230, arbuz: 0x2e7d32, slonecznik: 0xf6c600, zyto: 0xc9a44a,
};
const S = 2;

function diamond(scene, key, { fill, fillAlpha = 1, stroke, strokeAlpha = 0.3, furrows = false }) {
  const w = TILE_W * S, h = TILE_H * S;
  const g = scene.make.graphics({ x: 0, y: 0, add: false });
  g.fillStyle(fill, fillAlpha);
  g.lineStyle(2 * S, stroke, strokeAlpha);
  g.beginPath(); g.moveTo(w / 2, 1); g.lineTo(w - 1, h / 2); g.lineTo(w / 2, h - 1); g.lineTo(1, h / 2); g.closePath();
  g.fillPath(); g.strokePath();
  if (furrows) {
    g.lineStyle(3 * S, 0x3f2814, 0.5);
    for (let i = 0; i < 3; i++) {   // three short diagonal furrows across the middle
      g.beginPath();
      g.moveTo(w / 2 - 30 * S + i * 20 * S, h / 2 - 12 * S);
      g.lineTo(w / 2 - 10 * S + i * 20 * S, h / 2 + 12 * S);
      g.strokePath();
    }
  }
  g.generateTexture(key, w, h);
  g.destroy();
}

function circle(scene, key, r) {
  const g = scene.make.graphics({ x: 0, y: 0, add: false });
  g.fillStyle(0xffffff, 1); g.fillCircle(r, r, r);
  g.lineStyle(2 * S, 0x000000, 0.25); g.strokeCircle(r, r, r - S);
  g.generateTexture(key, 2 * r, 2 * r);
  g.destroy();
}

// A stand-in vehicle (body + two wheels), only for a key whose real art has not loaded.
const VEHICLE_TINT = { tractor: 0xd62828, seeder: 0xf2c230, harvester: 0x2e9e44 };
function vehicle(scene, key, tool, size) {
  const w = size === 2 ? 220 : 360, h = size === 2 ? 150 : 240;
  const g = scene.make.graphics({ x: 0, y: 0, add: false });
  g.fillStyle(VEHICLE_TINT[tool], 1); g.fillRoundedRect(w * 0.08, h * 0.2, w * 0.84, h * 0.5, 14);
  g.fillStyle(0xffffff, 0.9); g.fillRoundedRect(w * 0.5, h * 0.05, w * 0.3, h * 0.25, 8);
  g.fillStyle(0x222222, 1); g.fillCircle(w * 0.25, h * 0.75, h * 0.2); g.fillCircle(w * 0.75, h * 0.78, h * 0.16);
  g.generateTexture(key, w, h);
  g.destroy();
}

// The texture to draw a vehicle with: its real art once loaded, else the stand-in. The stand-in
// has its OWN key — generating it under the real key would make the loader skip the real file.
export const vehiclePlaceholderKey = (tool, size) => `farm_vehicle_ph_${tool}_${size}`;
export function vehicleTexture(scene, tool, size) {
  const real = vehicleKey(tool, size);
  return scene.textures.exists(real) ? real : vehiclePlaceholderKey(tool, size);
}

// Farm-object stand-ins (sub-project 4a) until the real farm_obj_* art loads.
function objectStandIn(scene, key, draw, w, h) {
  if (scene.textures.exists(key)) return;
  const g = scene.make.graphics({ x: 0, y: 0, add: false });
  draw(g, w, h);
  g.generateTexture(key, w, h);
  g.destroy();
}

function ensureObjectStandIns(scene) {
  objectStandIn(scene, 'farm_obj_ph_decoration', (g, w, h) => { g.fillStyle(0x9c6b3c, 1); g.fillRoundedRect(8, h * 0.3, w - 16, h * 0.6, 12); g.fillStyle(0x7ed957, 1); g.fillCircle(w / 2, h * 0.3, h * 0.22); }, 160, 140);
  objectStandIn(scene, 'farm_obj_ph_landmark', (g, w, h) => { g.fillStyle(0xc0392b, 1); g.fillRect(w * 0.1, h * 0.45, w * 0.8, h * 0.5); g.fillStyle(0x5d4037, 1); g.fillTriangle(w * 0.05, h * 0.47, w * 0.95, h * 0.47, w / 2, h * 0.08); }, 240, 220);
  objectStandIn(scene, 'farm_obj_ph_hay', (g, w, h) => { g.fillStyle(0xe8c547, 1); g.fillEllipse(w / 2, h * 0.6, w * 0.8, h * 0.6); }, 110, 90);
  objectStandIn(scene, 'farm_obj_ph_plaque', (g, w, h) => { g.fillStyle(0x6d4c2a, 1); g.fillRect(w / 2 - 5, h * 0.4, 10, h * 0.6); g.fillStyle(0xf2c230, 1); g.fillRoundedRect(8, 6, w - 16, h * 0.5, 8); }, 110, 130);
  objectStandIn(scene, 'farm_obj_ph_tree', (g, w, h) => { g.fillStyle(0x6d4c2a, 1); g.fillRect(w / 2 - 4, h * 0.55, 8, h * 0.45); g.fillStyle(0x4f9a3a, 1); g.fillCircle(w / 2, h * 0.4, w * 0.35); }, 90, 110);
  objectStandIn(scene, 'farm_obj_ph_fence_post', (g, w, h) => { g.fillStyle(0x8d5a2b, 1); g.fillRect(0, 0, w, h); }, 20, 60);
  objectStandIn(scene, 'farm_obj_ph_fence_rail', (g, w, h) => { g.lineStyle(8, 0xa0693a, 1); g.lineBetween(0, h * 0.35, w, h * 0.85); g.lineBetween(0, h * 0.05, w, h * 0.55); }, 60, 50);
}

export function ensureFarmPlaceholders(scene) {
  ensureObjectStandIns(scene);
  for (const tool of TOOLS) for (const size of [2, 4]) {
    const key = vehiclePlaceholderKey(tool, size);
    if (!scene.textures.exists(key)) vehicle(scene, key, tool, size);
  }
  if (scene.textures.exists(TILE_KEYS.grass)) return;
  diamond(scene, TILE_KEYS.grass,  { fill: 0x489847, stroke: 0x316d30 });   // the lawn's green (farm_tiles.py GRASS_RGB)
  diamond(scene, TILE_KEYS.fallow, { fill: 0xa77b4e, stroke: 0x6e4c2c });
  diamond(scene, TILE_KEYS.plowed, { fill: 0x7a4f2a, stroke: 0x3f2814, strokeAlpha: 0.6, furrows: true });
  diamond(scene, TILE_KEYS.hover,  { fill: 0xffffff, fillAlpha: 0.18, stroke: 0xffe066, strokeAlpha: 1 });
  diamond(scene, TILE_KEYS.queued, { fill: 0xffe066, fillAlpha: 0.22, stroke: 0xffb700, strokeAlpha: 1 });
  circle(scene, CROP_KEYS.seedling, 10 * S);
  circle(scene, CROP_KEYS.growing, 16 * S);
  circle(scene, CROP_KEYS.ready, 22 * S);
}
